<template>
  <div class="jumbotron relative h-full w-full fixed px-8">
    <div class="container mx-auto h-full flex items-center">
      <div>
        <h1 class="text-5xl font-bold text-white">
          Find your dream home
        </h1>
        <p class="text-gray-200">
          Submit your email and an agent we'll be contacting you soon
        </p>
        <div class="mt-4">
          <label for="client-email" class="absolute -t-1000 -l-1000">
            Insert your email
          </label>
          <input
            id="client-email"
            type="text"
            class="w-full md:w-64 h-12 px-6 py-4 rounded mr-2 focus:outline-none focus:shadow-outline focus:border-blue-300"
            placeholder="youremail@example.com"
          />
          <button
            id="submit-email"
            class="mt-4 md:mt-0 text-white font-bold h-12 px-6 rounded outline-none focus:outline-none bg-orange-500 active:bg-orange-600 uppercase text-sm shadow hover:shadow-lg"
          >
            Contact us
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheJumbotron"
};
</script>

<style lang="scss" scoped>
.jumbotron {
  height: 600px;
  background-image: url("~@/assets/images/header.jpg");
}
</style>
